import { Title } from 'src/onboarding/components/typography/Title/Title';
import styles from '../../styles/style.module.scss';
import { t } from '@web-solutions/module-localization';
import poster from '../../../../assets/images/poster.png';
import video from '../../styles/personalPlan2.mp4';

export const VideoComponent = () => {
  return (
    <>
      <Title tag='h4' className={styles.eatTitle}>
        {t('onboarding.personalPlan.eatLose.eat')}{' '}
        <span>{t('onboarding.personalPlan.eatLose.lose')}</span>
      </Title>
      <div className={styles.videoContainer}>
        <video controls={false} autoPlay muted loop playsInline preload='auto' poster={poster}>
          <source src={video} type='video/mp4' />
        </video>
      </div>
    </>
  );
};
